export const UserPermissionList = [
    {
        prop: "id",
        label: "id",
        width: "150",
        format: "",
        order: false,
        isShow: false
    },
    {
        prop: "userCode",
        label: "账号",
        width: "150",
        format: "",
        order: true,
        isShow: false
    },
    {
        prop: "nickName",
        label: "昵称",
        width: "150",
        format: "",
        order: true,
        isShow: true
    },
    {
        prop: "userName",
        label: "姓名",
        width: "150",
        format: "",
        order: true,
        isShow: false
    },
    {
        prop: "phone",
        label: "手机号",
        width: "150",
        format: "",
        order: true,
        isShow: true
    },
    {
        prop: "userMail",
        label: "邮箱",
        width: "150",
        format: "",
        order: true,
        isShow: true
    },
    {
        prop: "status",
        label: "状态",
        width: "150",
        format: "status",
        order: false,
        isShow: true
    },
    {
        prop: "companyName",
        label: "申请加入公司",
        width: "150",
        format: "",
        order: false,
        isShow: true
    },
    {
        prop: "creationTime",
        label: "创建时间",
        width: "150",
        format: "datetime",
        order: true,
        isShow: true
    },
    {
        prop: "creatorId",
        label: "创建人",
        width: "150",
        format: "",
        order: false,
        isShow: false
    },
    {
        prop: "lastModificationTime",
        label: "审核时间",
        width: "150",
        format: "datetime",
        order: true,
        isShow: true
    },
    {
        prop: "lastModifierId",
        label: "修改人",
        width: "150",
        format: "",
        order: false,
        isShow: false
    }
]



